import logomark from 'assets/logos/logomark.svg'
import { Link, useLocation } from 'react-router-dom'
import {
  closeDisconnect,
  openDisconnect,
  selectDisconnectOpen,
  disconnectWallet,
  openWidgetSignIn
} from 'state/slices/ui/widget'
import SignIn from 'components/common/SignIn'
import WalletDisconnect from 'components/wallet/WalletDisconnect'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { useWallet } from '@aptos-labs/wallet-adapter-react'
import { doMoneyGun } from 'state/thunks/doMoneyGun'
import { closeDetails, selectDetailsOpen } from 'state/slices/ui/form'
import { FullModal } from './FullModal'
import BrokerDetails from 'pages/BrokerDetails'
import { useRef } from 'react'
import { logAndToastError } from 'toolbox/toast'

function TopNav() {
  const { disconnect, connected, account, signAndSubmitTransaction, wallet } = useWallet()
  const isDisconnectOpen = useAppSelector(selectDisconnectOpen)
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()
  const targetElementRef = useRef(null)
  const isMSafe = wallet?.name === 'MSafe'

  const dashSelected = pathname === '/'
  const statsSelected = pathname.includes('/markets')
  const activitySelected = pathname.includes('/activity')
  const pointsSelected = pathname.includes('/points')
  const selectedStyle = 'selected'

  const dividerClass = !dashSelected ? 'divide' : ''
  const isDetailsOpen = useAppSelector(selectDetailsOpen)

  const envNet = process.env.REACT_APP_APTOS_NETWORK_SHORT || 'testnet'
  const isMainnet = envNet === 'mainnet'

  const tryDisconnect = async () => {
    try {
      await disconnect()
      disconnectWallet()
    } catch (e: any) {
      logAndToastError('Wallet', e.message)
    }
  }

  return (
    <>
      <div className={`nav-wrapper  ${dividerClass}`} ref={targetElementRef}>
        <nav className="top-nav">
          <div className="left-logo">
            <Link to="/">
              <img src={logomark} alt="superposition" className="logomark" />
            </Link>
            <p className="beta-tag">BETA</p>
          </div>
          <div className="mid-links piece">
            <Link to="/" className={`a-link bg-grey-select ${dashSelected ? selectedStyle : ''}`}>
              Dashboard
            </Link>
            <Link
              to="/markets"
              className={`a-link bg-grey-select ${statsSelected ? selectedStyle : ''}`}>
              Markets
            </Link>
            <Link
              to="/activity"
              className={`a-link bg-grey-select ${activitySelected ? selectedStyle : ''}`}>
              Activity
            </Link>
            <Link
              to="/points"
              className={`a-link bg-grey-select ${pointsSelected ? selectedStyle : ''}`}>
              Points
            </Link>
          </div>
          <div className="buttons">
            {!isMainnet && connected && (
              <button
                className="sp-btn tertiary global-mr"
                onClick={() =>
                  dispatch(
                    doMoneyGun({
                      address: account.address,
                      signAndSub: signAndSubmitTransaction,
                      coin: 'CoinB',
                      isMSafe
                    })
                  )
                }>
                APT
              </button>
            )}
            {!isMainnet && connected && (
              <button
                className="sp-btn tertiary global-mr"
                onClick={() =>
                  dispatch(
                    doMoneyGun({
                      address: account.address,
                      signAndSub: signAndSubmitTransaction,
                      coin: 'CoinA',
                      isMSafe
                    })
                  )
                }>
                USDC
              </button>
            )}
            {!isMainnet && connected && (
              <button
                className="sp-btn tertiary global-mr"
                onClick={() =>
                  dispatch(
                    doMoneyGun({
                      address: account.address,
                      signAndSub: signAndSubmitTransaction,
                      coin: 'CoinC',
                      isMSafe
                    })
                  )
                }>
                thAPT
              </button>
            )}
            {!isMainnet && connected && (
              <button
                className="sp-btn tertiary global-mr"
                onClick={() =>
                  dispatch(
                    doMoneyGun({
                      address: account.address,
                      signAndSub: signAndSubmitTransaction,
                      coin: 'StakedThalaAPT',
                      isMSafe
                    })
                  )
                }>
                sthAPT
              </button>
            )}
            {!isMainnet && connected && (
              <button
                className="sp-btn tertiary global-mr"
                onClick={() =>
                  dispatch(
                    doMoneyGun({
                      address: account.address,
                      signAndSub: signAndSubmitTransaction,
                      coin: 'AmnisAPT',
                      isMSafe
                    })
                  )
                }>
                amAPT
              </button>
            )}
            {!isMainnet && connected && (
              <button
                className="sp-btn tertiary global-mr"
                onClick={() =>
                  dispatch(
                    doMoneyGun({
                      address: account.address,
                      signAndSub: signAndSubmitTransaction,
                      coin: 'StakedAPT',
                      isMSafe
                    })
                  )
                }>
                stAPT
              </button>
            )}

            <SignIn open={openWidgetSignIn} connected={connected} disco={openDisconnect} />
            {isDisconnectOpen && (
              <WalletDisconnect disconnect={tryDisconnect} closeModal={closeDisconnect} />
            )}
          </div>
        </nav>
      </div>
      <FullModal open={isDetailsOpen} onClose={closeDetails}>
        <BrokerDetails />
      </FullModal>
    </>
  )
}

export default TopNav
